// Centralized product destinations linked from the homepage nav.
//
// Branding: the vault is AGENT-CURATED (Naro/Ciara coordinates yield) and VETA-GUARDED
// (every capital movement is verified before execution). Veta's control layer is VetaGate.
//
// Environment-aware wiring: when the landing page is itself viewed locally (i.e. during a
// design/voice consistency review with the whole product set running), the Vault and CLI
// dropdown entries point at the locally-running dev servers — vault (vite) on :5173 and
// cli (static) on :8080 — so you can click straight through from the nav. On the deployed
// domain they resolve to the production hosts instead. No localhost is baked into prod.
//
// Prod hosts: Vault dapp → vault.vishwalab.com, CLI demo → cli.vishwalab.com.
const isLocalReview =
  typeof window !== 'undefined' &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)

// Local dev servers, used only when the landing itself is served from localhost.
const LOCAL_VAULT_URL = 'http://localhost:5173'
const LOCAL_CLI_URL = 'http://localhost:8080'

export const APP_URL = isLocalReview ? LOCAL_VAULT_URL : 'https://vault.vishwalab.com' // Vishwa Vault dapp
export const CONTROL_LAYER_URL = 'https://www.vetagate.com' // VetaGate — the Veta control layer
export const MCP_CLI_URL = isLocalReview ? LOCAL_CLI_URL : 'https://cli.vishwalab.com' // Vishwa CLI demo
export const DOCS_URL = 'https://docs.vishwanetwork.xyz/' // developer docs
export const CONTACT_URL = 'https://form.typeform.com/to/IjCOn4nY' // "Talk to us" contact form

export interface ProductLink {
  key: string
  url: string
  label: string
  isBlank?: boolean
}

export const PRODUCT_ITEMS: ProductLink[] = [
  { key: 'app', url: APP_URL, label: 'BTCvp / CFvp Vault', isBlank: true },
  { key: 'control', url: CONTROL_LAYER_URL, label: 'VetaGate · Control Layer', isBlank: true },
  { key: 'mcp', url: MCP_CLI_URL, label: 'Vishwa CLI Demo', isBlank: true },
]
